import { applyConsent } from "./gtag_bridge.js";
import { logConsent } from "./backend_logger.js";

export function buildConfig() {
  return {
    cookie: {
      name: "sf_consent",
      expiresAfterDays: 365,
      sameSite: "Lax",
    },
    guiOptions: {
      consentModal: {
        layout: "box",
        position: "bottom right",
        flipButtons: false,
        equalWeightButtons: false,
      },
      preferencesModal: {
        layout: "box",
        flipButtons: false,
        equalWeightButtons: false,
      },
    },
    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {
        enabled: true,
        services: {
          ga4: {
            label: "Google Analytics 4",
            cookies: [
              { name: /^_ga/ },
              { name: "_gid" },
            ],
          },
        },
      },
      marketing: {
        enabled: true,
        services: {
          ads: {
            label: "Google Ads / Facebook Pixel",
            cookies: [
              { name: /^_fbp/ },
              { name: /^_gcl/ },
            ],
          },
        },
      },
    },
    onConsent: ({ cookie }) => {
      applyConsent({ accepted: cookie.categories || [] });
      // Backfill for users whose cookie predates the backend logger deploy.
      // logConsent() dedupes via localStorage so this is a one-time POST.
      logConsent("existing");
    },
    onFirstConsent: ({ cookie }) => {
      applyConsent({ accepted: cookie.categories || [] });
      logConsent("first_consent");
    },
    onChange: ({ cookie }) => {
      applyConsent({ accepted: cookie.categories || [] });
      logConsent("change");
    },
    language: {
      default: "sk",
      translations: {
        sk: {
          consentModal: {
            title: "Používame cookies",
            description: "Pre základné fungovanie stránky používame nevyhnutné cookies. Pre vylepšenie zážitku, analýzu návštevnosti a personalizáciu reklám by sme potrebovali váš súhlas. Viac informácií nájdete v <a href=\"/ochrana-osobnych-udajov\">ochrane osobných údajov</a>.",
            acceptAllBtn: "Prijať všetko",
            acceptNecessaryBtn: "Iba nevyhnutné",
            showPreferencesBtn: "Spravovať predvoľby",
          },
          preferencesModal: {
            title: "Predvoľby súhlasu",
            acceptAllBtn: "Prijať všetko",
            acceptNecessaryBtn: "Iba nevyhnutné",
            savePreferencesBtn: "Uložiť predvoľby",
            closeIconLabel: "Zatvoriť",
            sections: [
              {
                title: "Použitie cookies",
                description: "Cookies sú malé textové súbory ukladané vo vašom prehliadači. Niektoré sú nevyhnutné pre fungovanie stránky, iné nám pomáhajú zlepšovať služby.",
              },
              {
                title: "Nevyhnutné",
                description: "Pomáhajú stránke fungovať (prihlásenie, košík, bezpečnosť). Nedajú sa vypnúť.",
                linkedCategory: "necessary",
              },
              {
                title: "Analytické",
                description: "Anonymne sledujú návštevnosť (Google Analytics 4), aby sme vedeli, čo na stránke funguje.",
                linkedCategory: "analytics",
              },
              {
                title: "Marketingové",
                description: "Používajú sa na cielenie reklám (Google Ads, Facebook Pixel).",
                linkedCategory: "marketing",
              },
            ],
          },
        },
      },
    },
  };
}
